import { Injectable } from '@angular/core'
import { Observable, from } from 'rxjs'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { CouponsApiService } from 'src/app/builder-services/api/coupons.api.service'
import { UsersApiService } from 'src/app/builder-services/api/users.api.service'
import { productsTableColumns } from '../products/products.service'
import { categoriesTableColumns } from '../categories/categories.service'

export interface Coupon {
  name: string
  expirationDate: string
  amount: number
  discountType: 'percentage' | 'specific_amount'
  discountCriteria: 'fixed_products_discount' | 'fixed_categories_discount' | 'whole_cart_discount'
  usageTime: number
  usageTimes: number
  uses: number
  min: number
  max: number
  selectedProducts?: productsTableColumns[]
  selectedCategories?: categoriesTableColumns[]
  active: boolean
}
@Injectable({
  providedIn: 'root'
})
export class CouponsService {
  constructor(
    private builderService: BuilderService,
    private couponsApi: CouponsApiService,
    private usersApi: UsersApiService
  ) {}

  private get projectId(): string {
    return String(this.builderService.selectedProject)
  }

  submitCoupon(coupon: Coupon, _couponId: string = ''): Observable<any> {
    return from(
      this.couponsApi.insertCoupon(this.projectId, coupon).then(id => ({ key: id }))
    )
  }

  deleteCoupon(couponId: string): Observable<any> {
    return from(this.couponsApi.deleteCoupon(this.projectId, couponId))
  }

  getCoupon(couponId: string): Observable<Coupon> {
    return from(this.couponsApi.getCoupon(this.projectId, couponId)) as Observable<Coupon>
  }

  getCoupons(): Observable<any> {
    return from(
      this.couponsApi.getCoupons(this.projectId).then(coupons => {
        if (!coupons.length) return {}
        return coupons.reduce((acc: any, c: any) => { acc[c.id] = c; return acc }, {})
      })
    )
  }

  updateCoupon(id: string, coupon: Coupon): Observable<any> {
    return from(this.couponsApi.updateCoupon(this.projectId, id, coupon))
  }

  trackCouponUsage(couponId: string, userId: string): Observable<void> {
    return from(this.couponsApi.trackCouponUsage(this.projectId, couponId, userId))
  }

  incrementCouponUses(couponId: string): Observable<void> {
    return from(this.couponsApi.incrementCouponUses(this.projectId, couponId))
  }

  getCouponUsers(couponId: string): Observable<any[]> {
    return from(this.couponsApi.getCouponUsers(this.projectId, couponId))
  }

  getUsers(): Observable<any> {
    return from(this.usersApi.getUsers(this.projectId))
  }
}
